/** Where the API lives. Same-origin by default: Vite dev-proxies `/api`
 * to the local Core Platform, Traefik routes it in production
 * (Infrastructure Architecture §5). Override with `VITE_API_BASE_URL`. */
export const API_BASE_URL = (import.meta.env.VITE_API_BASE_URL ?? '/api/v1').replace(/\/$/, '');
